export const environment = {
  production: true,
  apiKey: '7ada9becc7b3dd8944a24b0555af4e41768c977798b9b4ef40d1b2bf43aa8225',
  apiURL: 'https://api.bandon.ch',
};
